export default __webpack_public_path__ + "static/media/paso2.511d0498.svg";